import { action, computed, makeObservable, observable, toJS } from 'mobx'

import type { AccountSystemUserAiAgentResponse } from '@src/service/dto/response/AccountSystemUserAiAgentResponse'
import SystemUserModel from '@src/service/model/SystemUserModel'
import type { Identity } from '@src/service/model/base'
import { getAiAgentConstants } from '@src/shared/aiAgentConstants'

const defaultAiAgentConstants = getAiAgentConstants(false)

export type RawSystemUserAiAgent = AccountSystemUserAiAgentResponse

export class SystemUserAiAgentModel {
  private raw: RawSystemUserAiAgent
  systemUser: SystemUserModel

  constructor(attrs: RawSystemUserAiAgent) {
    this.raw = attrs
    this.systemUser = new SystemUserModel({
      id: attrs.id,
      orgId: attrs.orgId,
      type: 'ai-agent',
    })

    makeObservable<this, 'raw'>(this, {
      raw: observable.deep,
      id: computed,
      deserialize: action.bound,
    })
  }

  get id() {
    return this.raw.id
  }

  get orgId() {
    return this.raw.orgId
  }

  get identity(): Identity {
    return {
      id: this.raw.id,
      emailAddresses: [],
      initials: this.raw.initials,
      isAnonymous: false,
      name: this.raw.name,
      shortName: this.raw.shortName,
      phones: [
        {
          id: this.raw.phoneNumber.id,
          number: this.raw.phoneNumber.number,
          name: this.raw.phoneNumber.id,
          symbol: '📞',
        },
      ],
      pictureUrl: defaultAiAgentConstants.lightAvatar,
      pictureUrlDark: defaultAiAgentConstants.darkAvatar,
    }
  }

  get phoneNumber() {
    return this.raw.phoneNumber.number
  }

  deserialize(json: RawSystemUserAiAgent): this {
    this.raw = json
    return this
  }

  serialize(): RawSystemUserAiAgent {
    return toJS(this.raw)
  }
}
